import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Mail, Phone, User, Building, MessageSquare, Send, CheckCircle, ArrowLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const FaleConosco = () => {
  const { t } = useTranslation()
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', company: '', assunto: '', message: '' })
  const [isSubmitted, setIsSubmitted] = useState(false)

  const handleChange = (e) => setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }))

  const handleSubmit = (e) => {
    e.preventDefault()
    const subject = `[${formData.assunto || t('forms.subjectOptions.outros')}] ${formData.name}`
    const body = [
      'Novo contato pelo site',
      '',
      `Nome: ${formData.name}`,
      `Email: ${formData.email}`,
      `Telefone: ${formData.phone}`,
      `Empresa: ${formData.company || 'Não informado'}`,
      `Assunto: ${formData.assunto || 'Não informado'}`,
      '',
      'Mensagem:',
      formData.message,
    ].join('\n')
    window.location.href = `mailto:contato@agsgloballogistics.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
    setIsSubmitted(true)
    setTimeout(() => {
      setIsSubmitted(false)
      setFormData({ name: '', email: '', phone: '', company: '', assunto: '', message: '' })
    }, 3000)
  }

  const inputClass = "w-full pl-12 pr-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-sky-400 focus:border-transparent transition-all"
  const labelClass = "block text-sm font-semibold text-white/80 mb-2"

  return (
    <div className="min-h-screen pt-20" style={{ backgroundColor: '#0C2D54' }}>
      <div className="container-custom py-16">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="max-w-2xl mx-auto">

          <Link to="/contato" className="inline-flex items-center gap-2 text-sm text-white/55 hover:text-white transition-colors mb-8">
            <ArrowLeft size={16} /> {t('forms.back')}
          </Link>

          <div className="mb-10">
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4">
              {t('faleConosco.title')} <span style={{ color: '#38bdf8' }}>{t('faleConosco.titleHighlight')}</span>
            </h1>
            <p className="text-white/65 text-base leading-relaxed">
              {t('faleConosco.subtitle')}
            </p>
          </div>

          <div className="rounded-2xl p-8" style={{ backgroundColor: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.12)' }}>
            {isSubmitted ? (
              <div className="text-center py-8">
                <CheckCircle className="w-16 h-16 text-green-400 mx-auto mb-4" />
                <h3 className="text-2xl font-bold text-white mb-2">{t('forms.success')}</h3>
                <p className="text-white/65">{t('forms.successText')}</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-5">
                <div className="grid md:grid-cols-2 gap-5">
                  <div>
                    <label className={labelClass}>{t('forms.name')} {t('forms.required')}</label>
                    <div className="relative">
                      <User className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" size={20} />
                      <input type="text" name="name" value={formData.name} onChange={handleChange} required className={inputClass} placeholder={t('forms.namePlaceholder')} />
                    </div>
                  </div>
                  <div>
                    <label className={labelClass}>{t('forms.email')} {t('forms.required')}</label>
                    <div className="relative">
                      <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" size={20} />
                      <input type="email" name="email" value={formData.email} onChange={handleChange} required className={inputClass} placeholder={t('forms.emailPlaceholder')} />
                    </div>
                  </div>
                  <div>
                    <label className={labelClass}>{t('forms.phone')} {t('forms.required')}</label>
                    <div className="relative">
                      <Phone className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" size={20} />
                      <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required className={inputClass} placeholder={t('forms.phonePlaceholder')} />
                    </div>
                  </div>
                  <div>
                    <label className={labelClass}>{t('forms.company')}</label>
                    <div className="relative">
                      <Building className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" size={20} />
                      <input type="text" name="company" value={formData.company} onChange={handleChange} className={inputClass} placeholder={t('forms.companyPlaceholder')} />
                    </div>
                  </div>
                </div>
                <div>
                  <label className={labelClass}>{t('forms.subject')} {t('forms.required')}</label>
                  <select name="assunto" value={formData.assunto} onChange={handleChange} required className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white focus:outline-none focus:ring-2 focus:ring-sky-400 focus:border-transparent transition-all">
                    <option value="" className="bg-[#0C2D54]">{t('forms.subjectPlaceholder')}</option>
                    <option value={t('forms.subjectOptions.sugestao')} className="bg-[#0C2D54]">{t('forms.subjectOptions.sugestao')}</option>
                    <option value={t('forms.subjectOptions.reclamacao')} className="bg-[#0C2D54]">{t('forms.subjectOptions.reclamacao')}</option>
                    <option value={t('forms.subjectOptions.elogio')} className="bg-[#0C2D54]">{t('forms.subjectOptions.elogio')}</option>
                    <option value={t('forms.subjectOptions.outros')} className="bg-[#0C2D54]">{t('forms.subjectOptions.outros')}</option>
                  </select>
                </div>

                <div>
                  <label className={labelClass}>{t('forms.message')} {t('forms.required')}</label>
                  <div className="relative">
                    <MessageSquare className="absolute left-3 top-4 text-white/40" size={20} />
                    <textarea name="message" value={formData.message} onChange={handleChange} required rows="5" className={`${inputClass} resize-none`} placeholder={t('faleConosco.messagePlaceholder')} />
                  </div>
                </div>
                <button type="submit" className="w-full flex items-center justify-center gap-2 py-3 px-6 rounded-lg font-semibold text-white transition-all duration-300 hover:brightness-110" style={{ backgroundColor: '#38bdf8', color: '#0C2D54' }}>
                  <Send size={20} />
                  {t('forms.send')}
                </button>
              </form>
            )}
          </div>
        </motion.div>
      </div>
    </div>
  )
}

export default FaleConosco
